export default "__VITE_ASSET__CQYlTjGN__"